import type { FaireProductEntity } from "../../entity_types/product";

export const p_wggg8976qy: FaireProductEntity = {
  token: "p_wggg8976qy",
  type: "product",
  name: "Barbican Bottle Opener",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/7ed6ce4438cd568e8187034cdc2fcb6603aeb753e4e775f0c0446ce3dc6a306b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6a8bbbcf57daffccc551ef8ce8d90d18a8a44daacb38a7e9959eac610cb431b2.jpeg",
    "https://cdn.faire.com/fastly/e6971c06efc54575e04993ddf25830ba1b8973804e93142050567ac394eb3d4f.jpeg",
    "https://cdn.faire.com/fastly/a03620b0eb919359f19e195a504ddb88a6d8c8256800af43e4bdb4f7d85326f1.jpeg",
  ],
  priceDollars: 25,
  description:
    "BARBICAN is a barware collection inspired by the bold lines and functionality of brutalist architecture. The BARBICAN Bottle Opener is a visually striking everyday tool that pairs rich materiality with timeless utility. Crafted from solid brass, its reassuring weight and clean, sculptural profile make the form feel purposeful in the hand.\n\nMaterial: brass\nSize: 2 x 1.8 x 14.3 cm / 0.8” x 0.7” x 5.6”\nCare instructions: Brass will tarnish and discolour with time. To clean, use a gentle non-abrasive metal polish.",
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:28.863Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
